import React from 'react'

import Loading from '../../assets/loading.svg'
import TextMode from '../../assets/text-mode.svg'
import VideoMode from '../../assets/video-mode.svg'
import { Container, Wrapper, ImageModeWrapper, Loader } from './styles'
import { createModalPortal } from 'utils/createModalPortal'

interface FormatModalProps {
  isModeApresentation?: string
}

const FormatModal: React.FC<FormatModalProps> = ({ isModeApresentation }) => {
  return createModalPortal(
    <Container>
      <Wrapper>
        <ImageModeWrapper>
          <img
            src={isModeApresentation === 'text' ? TextMode : VideoMode}
            alt={
              isModeApresentation === 'text'
                ? 'Alterando para modo vídeo'
                : 'Alterando para modo livro digital'
            }
          />
        </ImageModeWrapper>
        <Loader src={Loading} alt="Carregando" />
        <h2 id="content">
          Alterando para modo {isModeApresentation === 'text' ? 'livro digital' : 'vídeo'}...
        </h2>
      </Wrapper>
    </Container>
  )
}

export default FormatModal
